import {base64DecodeUnicode} from "./utilities/base64";
import {initInputBody} from "./inputfile";
import {initInputMaskDate} from "./inputMaskDate";
import {initPhoneCountryFields} from "./phoneCountryField";
import {focusInputGroups} from "./checkInputGroups";
import {initLocationDropdown} from "./locationDropdown";

// Globale Funktion zum Holen des Listing-Titels
function getListingTitle() {
    const urlParams = new URLSearchParams(window.location.search);
    const listingFromUrl = urlParams.get('listing');
    if (listingFromUrl) return listingFromUrl;

    try {
        return localStorage.getItem('listingTitle');
    } catch (e) {
        return null;
    }
}

// Setzt den Wert auf #input_hidden
function setInputHiddenValue() {
    const listingTitle = getListingTitle();
    if (!listingTitle) return;

    const input = document.querySelector('#input_hidden');
    if (input && input.value !== listingTitle) {
        input.value = listingTitle;
        input.setAttribute('value', listingTitle);
    }
}

// Initialisiert Location-Dropdown falls noch nicht geschehen
function ensureLocationDropdownInit() {
    const dropdown = document.querySelector('#input_choose_location');
    if (!dropdown || dropdown.dataset.locationInitialized) return;

    // Prüfen ob die Optionen noch den "location:email" Wert haben (= noch nicht initialisiert)
    const firstOptionWithColon = Array.from(dropdown.options).find(o => o.value.includes(':'));
    if (firstOptionWithColon) {
        dropdown.dataset.locationInitialized = 'true';
        const wrapper = dropdown.closest('.js-RecaptchaForm') || dropdown.closest('form')?.parentElement || document;
        initLocationDropdown(wrapper);
    }
}

// Kontinuierliches Polling - läuft die ganze Zeit
function startContinuousPolling() {
    setInputHiddenValue();
    ensureLocationDropdownInit();

    setInterval(() => {
        setInputHiddenValue();
        ensureLocationDropdownInit();
    }, 50);
}

// MutationObserver für DOM-Änderungen (Cookie-Banner, Form-Loading, etc.)
function setupMutationObserver() {
    const observer = new MutationObserver(() => {
        setInputHiddenValue();
        ensureLocationDropdownInit();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'data-html']
    });
}

// Event-Listener für Cookie-Accept-Button
function setupCookieAcceptListener() {
    document.addEventListener('click', (e) => {
        if (e.target.closest('.dcCookieHelper--buttonExternalAccept')) {
            const attempts = [50, 100, 200, 300, 500, 750, 1000, 1500, 2000];
            attempts.forEach(delay => {
                setTimeout(() => {
                    setInputHiddenValue();
                    ensureLocationDropdownInit();
                }, delay);
            });
        }
    });
}

// Sofort starten - nicht auf DOMContentLoaded warten
startContinuousPolling();
setupCookieAcceptListener();

// Observer starten sobald body existiert
if (document.body) {
    setupMutationObserver();
} else {
    document.addEventListener('DOMContentLoaded', setupMutationObserver);
}

function loadRecaptchaHtml(formWrapper) {
    const phoneFields = formWrapper.querySelectorAll("input[type=tel]");
    phoneFields.forEach(field => {
        const instance = window.intlTelInputGlobals?.getInstance(field);
        if (instance) {
            instance.destroy();
        }
    });

    // Titel aus URL-Parameter oder localStorage holen
    const urlParams = new URLSearchParams(window.location.search);
    const listingFromUrl = urlParams.get('listing');
    let listingTitle = listingFromUrl;

    // Fallback auf localStorage
    if (!listingTitle) {
        try {
            listingTitle = localStorage.getItem('listingTitle');
        } catch (e) {
            // localStorage blockiert
        }
    }

    formWrapper.innerHTML = base64DecodeUnicode(formWrapper.dataset.html);

    const form = formWrapper.querySelector("form");

    initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate'));
    initInputBody(formWrapper.querySelectorAll('.fileBody'));
    initPhoneCountryFields(formWrapper.querySelectorAll("input[type=tel]"));
    focusInputGroups(formWrapper.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
    initLocationDropdown(formWrapper);

    // Titel setzen
    if (listingTitle) {
        const titleElement = formWrapper.querySelector('.listingContactTitle');
        if (titleElement) {
            titleElement.textContent = listingTitle.split(' (')[0];
        }

        // Hidden Input setzen (wird auch vom globalen Polling gesetzt)
        const hiddenInput = form.querySelector('#input_hidden');
        if (hiddenInput) {
            hiddenInput.value = listingTitle;
            hiddenInput.setAttribute('value', listingTitle);
        }
    }

    form.addEventListener("submit", function (e) {
        e.preventDefault();
        localStorage.removeItem('listingTitle');
        grecaptcha.execute();
    });
}

export function initRecaptchaForms() {
    const observer = new MutationObserver(function (mutationList, observer) {
        for (let mutation of mutationList) {
            let target = mutation.target;
            if (target && !target.dataset.recaptchaInitialized) {
                target.dataset.recaptchaInitialized = 'true';
                loadRecaptchaHtml(target);
            }
        }
    });

    for (let form of document.querySelectorAll('.js-RecaptchaForm')) {
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
}
